import { environment } from "src/environments/environment";

export const passwordPattern =
  "^(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])[^ ]{8,32}$";
export const vatIdPattern = "^[a-zA-Z0-9]{5,15}$";
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const DATA_MANAGEMENT_USER_IDS = new Set(
  environment.dataManagementUserIds.map(String),
);

interface DataManagementIdentity {
  userId?: string | number | null;
  role?: string | null;
}

export function canManageDataManagement(
  identity: DataManagementIdentity | null | undefined,
): boolean {
  const userId = identity?.userId?.toString();
  const role = identity?.role?.toString().toLowerCase();

  return (
    role === "admin" &&
    !!userId &&
    DATA_MANAGEMENT_USER_IDS.has(userId)
  );
}
